import React, { useState, useEffect, useRef } from 'react';
import { useTranslation } from 'react-i18next';
import { Button } from './ui/button';

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

const Music = () => {
  const { t } = useTranslation();
  const [tracks, setTracks] = useState([]);
  const [currentTrack, setCurrentTrack] = useState(null);
  const [currentVersion, setCurrentVersion] = useState(null);
  const [isPlaying, setIsPlaying] = useState(false);
  const [loading, setLoading] = useState(true);
  const [searchTerm, setSearchTerm] = useState('');
  const [sortBy, setSortBy] = useState('newest'); // newest, oldest, alphabetical
  const [audioLoadingStates, setAudioLoadingStates] = useState({}); // Track audio loading per track
  const audioRef = useRef(null);
  const preloadRefs = useRef({}); // Multiple audio elements for preloading

  useEffect(() => {
    // Extended mock data for 50+ songs demonstration
    const mockTracks = [
      {
        id: "take-my-hand-2026",
        title: "Take My Hand",
        duration: "4:00",
        year: "2026",
        album: "SYNTETIK",
        description: "Una invitación a dejarse llevar, donde las texturas sintéticas envuelven al oyente en un viaje sensorial",
        vocalVersion: "https://0xx2mevl0on6cu8y.public.blob.vercel-storage.com/Take%20My%20Hand%20Master%20Final.mp3",
        instrumentalVersion: "#",
        track_type: "vocal",
        play_count: 0,
        spotifyUrl: "https://open.spotify.com/track/3YBfAgcbJfQPeYJD7EzR7R"
      },
      {
        id: "afternoon-2026",
        title: "Afternoon with Myself",
        duration: "4:15",
        year: "2026",
        album: "SYNTETIK",
        description: "Una tarde de introspección donde el tiempo se detiene y las emociones fluyen en melodías sintéticas",
        vocalVersion: "https://0xx2mevl0on6cu8y.public.blob.vercel-storage.com/audio%20fnal%20Aftnoon%20with%20my%20self.mp3",
        instrumentalVersion: "#",
        track_type: "vocal",
        play_count: 0,
        spotifyUrl: "https://open.spotify.com/track/56aJDJEYj9RTd5RzdCp2tW"
      },
      {
        id: "uplight-2026",
        title: "UPLIGHT",
        duration: "4:32",
        year: "2025",
        album: "SYNTETIK",
        description: "Una experiencia luminosa que eleva el espíritu, fusionando texturas sintéticas con emociones transformadoras",
        vocalVersion: "https://0xx2mevl0on6cu8y.public.blob.vercel-storage.com/UPLIGHT%20-%20Audio%20Animals%20Master%202.wav",
        instrumentalVersion: "#",
        track_type: "instrumental",
        play_count: 0,
        spotifyUrl: "https://open.spotify.com/track/2IH7bHyPNBQ6jGF2UT4vPS"
      },
      {
        id: "1",
        title: "Floating in Time",
        duration: "4:23",
        year: "2025",
        album: "SYNTETIK",
        description: "A haunting journey through memory and desire",
        vocalVersion: "https://0xx2mevl0on6cu8y.public.blob.vercel-storage.com/Floating%20In%20Time%20Master%202.mp3",
        instrumentalVersion: "https://0xx2mevl0on6cu8y.public.blob.vercel-storage.com/Time%20Retreat%20-%20Audio%20Animals%20Instrumental%20Master%204.wav",
        play_count: 0,
        spotifyUrl: "https://open.spotify.com/track/0bEsaNOtREMXFqiPxC7hfE",
        spotifyUrlInstrumental: "https://open.spotify.com/track/6UukZ5s31yU0KNvuJBFnmv"
      },
      {
        id: "2",
        title: "Shades",
        duration: "3:45",
        year: "2025",
        album: "SYNTETIK",
        description: "Atmospheric electronic soundscape with haunting melodies",
        vocalVersion: "https://0xx2mevl0on6cu8y.public.blob.vercel-storage.com/SHADES%20FINAL%20matster%2048.mp3",
        instrumentalVersion: "#",
        play_count: 0,
        spotifyUrl: "https://open.spotify.com/track/3oJScnk3XI5hQRmzb89klx"
      },
      {
        id: "3",
        title: "Insane",
        duration: "4:15",
        year: "2025",
        album: "SYNTETIK",
        description: "Intense electronic journey with powerful vocals",
        vocalVersion: "https://0xx2mevl0on6cu8y.public.blob.vercel-storage.com/INSANE%20-%20Audio%20Animals%20Master.wav",
        instrumentalVersion: "#",
        play_count: 0,
        spotifyUrl: "https://open.spotify.com/track/4MFRRRaPCUvZduPzqzjOHG"
      },
      {
        id: "4",
        title: "Its Over",
        duration: "3:55",
        year: "2025",
        album: "SYNTETIK",
        description: "Emotional finale with powerful lyrics and melodies",
        vocalVersion: "https://0xx2mevl0on6cu8y.public.blob.vercel-storage.com/Its%20Over%20Lyrics.MP3",
        instrumentalVersion: "#",
        play_count: 0,
        spotifyUrl: "https://open.spotify.com/track/0wI3fdragL3ICjxUBPWQoI"
      },
      {
        id: "5",
        title: "Odyssey",
        duration: "4:32",
        year: "2025",
        album: "SYNTETIK",
        description: "Epic musical journey through soundscapes and emotions",
        vocalVersion: "https://0xx2mevl0on6cu8y.public.blob.vercel-storage.com/Copia%20de%20oddYsey%20-%20Audio%20Animals%20Master%203.mp3",
        instrumentalVersion: "#",
        play_count: 0,
        spotifyUrl: "https://open.spotify.com/track/1Le9BmOybAYtPwzmzUpmTP"
      },
      {
        id: "6",
        title: "When I Wake",
        duration: "4:12",
        year: "2025",
        album: "SYNTETIK",
        description: "The awakening to a world transformed, where reality shifts with consciousness",
        vocalVersion: "https://0xx2mevl0on6cu8y.public.blob.vercel-storage.com/When%20i%20wake%20mp3%20Version%20Publica.mp3",
        instrumentalVersion: "#",
        track_type: "vocal",
        play_count: 0,
        spotifyUrl: "https://open.spotify.com/track/2CyCmaIHAyuna8Yd9iqNiz"
      }
    ];
    
    setTracks(mockTracks);
    setLoading(false);
  }, []);

  // Preload multiple tracks for instant playback
  useEffect(() => {
    if (tracks.length > 0) {
      // Preload first 3 tracks for instant response
      tracks.slice(0, 3).forEach((track, index) => {
        if (track.vocalVersion && track.vocalVersion !== '#') {
          const preloadAudio = new Audio();
          preloadAudio.preload = 'auto';
          preloadAudio.src = track.vocalVersion;
          preloadRefs.current[`${track.id}-vocal`] = preloadAudio;
          
          // Set loading state
          setAudioLoadingStates(prev => ({
            ...prev,
            [`${track.id}-vocal`]: 'loading'
          }));
          
          // Handle load events
          preloadAudio.oncanplaythrough = () => {
            setAudioLoadingStates(prev => ({
              ...prev,
              [`${track.id}-vocal`]: 'ready'
            }));
          };
          
          preloadAudio.onerror = () => {
            setAudioLoadingStates(prev => ({
              ...prev,
              [`${track.id}-vocal`]: 'error'
            }));
          };
        }
      });
    }
    
    // Cleanup preloaded audio on unmount
    return () => {
      Object.values(preloadRefs.current).forEach(audio => {
        if (audio) {
          audio.pause();
          audio.src = '';
        }
      });
      preloadRefs.current = {};
    };
  }, [tracks]);

  const handlePlayPause = async (track, version = 'vocal') => {
    console.log('🎵 Play clicked:', track.title, version);
    
    // Handle pause if same track and version is playing
    if (currentTrack?.id === track.id && currentVersion === version && isPlaying) {
      audioRef.current.pause();
      setIsPlaying(false);
      console.log('🎵 Paused audio');
      return;
    }

    const audioUrl = version === 'vocal' ? track.vocalVersion : track.instrumentalVersion;
    
    if (!audioUrl || audioUrl === '#') {
      alert('Audio URL not found');
      return;
    }

    console.log('🎵 Using audio URL:', audioUrl);
    const preloadKey = `${track.id}-${version}`;
    
    // Set states immediately for instant UI feedback
    setCurrentTrack(track);
    setCurrentVersion(version);
    setIsPlaying(true);

    try {
      // Stop any currently playing audio
      audioRef.current.pause();
      
      // Check if we have a preloaded version
      const preloadedAudio = preloadRefs.current[preloadKey];
      
      if (preloadedAudio && audioLoadingStates[preloadKey] === 'ready') {
        console.log('🎵 Using preloaded audio for instant play');
        
        // Transfer the preloaded audio to main player
        audioRef.current.src = preloadedAudio.src;
        audioRef.current.currentTime = 0;
        
        const playPromise = audioRef.current.play();
        
        if (playPromise !== undefined) {
          playPromise
            .then(() => {
              console.log('🎵 Preloaded audio playing instantly');
            })
            .catch(error => {
              console.error('🎵 Preloaded audio play error:', error);
              setIsPlaying(false);
            });
        }
      } else {
        console.log('🎵 Loading audio on demand');
        // Fallback to regular loading
        audioRef.current.src = audioUrl;
        audioRef.current.currentTime = 0;
        audioRef.current.load();
        
        const playPromise = audioRef.current.play();
        
        if (playPromise !== undefined) {
          playPromise
            .then(() => {
              console.log('🎵 Audio playing successfully');
            })
            .catch(error => {
              console.error('🎵 Audio play error:', error);
              setIsPlaying(false);
              alert('Error playing audio. Please try clicking somewhere on the page first to enable audio.');
            });
        }
      }
      
      // Track play event
      try {
        await fetch(`${API}/tracks/${track.id}/play`, { method: 'POST' });
      } catch (error) {
        console.error('Failed to track play:', error);
      }
      
    } catch (error) {
      console.error('🎵 Audio setup error:', error);
      setIsPlaying(false);
      alert('Error setting up audio playback.');
    }
  };

  // Filter and sort tracks
  const filteredTracks = tracks
    .filter(track => 
      track.title.toLowerCase().includes(searchTerm.toLowerCase()) ||
      track.album.toLowerCase().includes(searchTerm.toLowerCase())
    )
    .sort((a, b) => {
      switch(sortBy) {
        case 'alphabetical':
          return a.title.localeCompare(b.title);
        case 'oldest':
          return parseInt(a.year) - parseInt(b.year);
        case 'newest':
        default:
          return parseInt(b.year) - parseInt(a.year);
      }
    });

  if (loading) {
    return (
      <section id="music" className="py-24 px-6 bg-gradient-to-b from-gray-900/50 to-black">
        <div className="max-w-7xl mx-auto">
          <div className="animate-pulse">
            <div className="h-16 bg-gray-700 rounded mb-8"></div>
            <div className="space-y-4">
              {[...Array(5)].map((_, i) => (
                <div key={i} className="h-16 bg-gray-700 rounded"></div>
              ))}
            </div>
          </div>
        </div>
      </section>
    );
  }

  return (
    <section id="music" className="py-24 px-6 bg-gradient-to-b from-gray-900/50 to-black">
      <audio 
        ref={audioRef} 
        preload="metadata"
        crossOrigin="anonymous"
      />
      
      <div className="max-w-7xl mx-auto">
        {/* Video de BLOISE tocando sintetizador */}
        <div className="mb-16">
          <video
            src="https://0xx2mevl0on6cu8y.public.blob.vercel-storage.com/BLOISE%20PLAYING%20SYNTH.mp4"
            autoPlay
            loop
            muted
            playsInline
            className="w-full rounded-lg shadow-lg border border-white/10"
          />
        </div>

        {/* Header */}
        <div className="text-center mb-16">
          <h2 className="text-5xl md:text-7xl font-light tracking-wider text-transparent bg-clip-text bg-gradient-to-r from-blue-200 to-white mb-8">
            {t('music.title')}
          </h2>
          <p className="text-xl text-gray-300 font-light max-w-2xl mx-auto mb-8">
            {t('music.subtitle')}
          </p>
        </div>

        {/* Controls */}
        <div className="flex flex-col md:flex-row gap-4 mb-8">
          <div className="flex-1">
            <input
              type="text"
              placeholder="Search tracks or albums..."
              value={searchTerm}
              onChange={(e) => setSearchTerm(e.target.value)}
              className="w-full bg-black/30 border border-white/20 text-white placeholder:text-gray-400 px-4 py-3 rounded-lg focus:border-blue-400 focus:outline-none"
            />
          </div>
          <select
            value={sortBy}
            onChange={(e) => setSortBy(e.target.value)}
            className="bg-black/30 border border-white/20 text-white px-4 py-3 rounded-lg focus:border-blue-400 focus:outline-none"
          >
            <option value="newest">Newest First</option>
            <option value="oldest">Oldest First</option>
            <option value="alphabetical">A-Z</option>
          </select>
        </div>

        {/* Now Playing Banner */}
        {currentTrack && isPlaying && (
          <div className="bg-gradient-to-r from-blue-900/30 to-purple-900/30 border border-blue-400/30 rounded-lg p-4 mb-8 backdrop-blur-sm">
            <div className="flex items-center justify-between">
              <div className="flex items-center space-x-4">
                <div className="w-3 h-3 bg-blue-400 rounded-full animate-pulse"></div>
                <div>
                  <p className="text-blue-300 text-sm font-light">NOW PLAYING</p>
                  <h4 className="text-white font-light text-lg">{currentTrack.title}</h4>
                  <p className="text-gray-400 text-sm">
                    {currentVersion === 'vocal' ? 'Vocal Version' : 'Instrumental Version'} • {currentTrack.album}
                  </p>
                </div>
              </div>
              <Button
                onClick={() => handlePlayPause(currentTrack, currentVersion)}
                className="w-12 h-12 rounded-full bg-blue-500/20 border border-blue-400 text-blue-400 hover:bg-blue-500/30"
              >
                ⏸
              </Button>
            </div>
          </div>
        )}

        {/* Tracks List */}
        <div className="space-y-2">
          {filteredTracks.map((track, index) => (
            <div
              key={track.id}
              className="group bg-black/20 hover:bg-black/40 border border-white/10 hover:border-blue-400/30 rounded-lg p-4 transition-all duration-300"
            >
              <div className="flex items-center justify-between">
                {/* Track Info */}
                <div className="flex items-center space-x-4 flex-1">
                  <div className="text-gray-400 text-sm font-mono w-8">
                    {String(index + 1).padStart(2, '0')}
                  </div>
                  <div className="flex-1 min-w-0">
                    <h3 className="text-white font-light text-lg group-hover:text-blue-200 transition-colors truncate">
                      {track.title}
                    </h3>
                    <div className="flex items-center space-x-4 text-sm text-gray-400">
                      <span>{track.album}</span>
                      <span>•</span>
                      <span>{track.year}</span>
                      <span>•</span>
                      <span>{track.duration}</span>
                    </div>
                  </div>
                </div>

                {/* Play Controls */}
                <div className="flex items-center space-x-2">
                  {/* Spotify Button */}
                  {track.spotifyUrl && (
                    <a
                      href={track.spotifyUrl}
                      target="_blank"
                      rel="noopener noreferrer"
                      data-testid={`spotify-btn-${track.id}`}
                      className="w-10 h-10 rounded-full border border-[#1DB954]/40 bg-[#1DB954]/10 flex items-center justify-center transition-all duration-300 hover:border-[#1DB954] hover:bg-[#1DB954]/20 hover:scale-110"
                      title="Listen on Spotify"
                    >
                      <svg className="w-5 h-5 text-[#1DB954]" viewBox="0 0 24 24" fill="currentColor">
                        <path d="M12 0C5.4 0 0 5.4 0 12s5.4 12 12 12 12-5.4 12-12S18.66 0 12 0zm5.521 17.34c-.24.359-.66.48-1.021.24-2.82-1.74-6.36-2.101-10.561-1.141-.418.122-.779-.179-.899-.539-.12-.421.18-.78.54-.9 4.56-1.021 8.52-.6 11.64 1.32.42.18.479.659.301 1.02zm1.44-3.3c-.301.42-.841.6-1.262.3-3.239-1.98-8.159-2.58-11.939-1.38-.479.12-1.02-.12-1.14-.6-.12-.48.12-1.021.6-1.141C9.6 9.9 15 10.561 18.72 12.84c.361.181.54.78.241 1.2zm.12-3.36C15.24 8.4 8.82 8.16 5.16 9.301c-.6.179-1.2-.181-1.38-.721-.18-.601.18-1.2.72-1.381 4.26-1.26 11.28-1.02 15.721 1.621.539.3.719 1.02.419 1.56-.299.421-1.02.599-1.559.3z"/>
                      </svg>
                    </a>
                  )}

                  {/* Primary Version (Vocal or Instrumental based on track_type) */}
                  <Button
                    onClick={() => handlePlayPause(track, 'vocal')}
                    disabled={track.vocalVersion === "#"}
                    className={`w-10 h-10 rounded-full border transition-all duration-300 text-xs ${
                      currentTrack?.id === track.id && currentVersion === 'vocal' && isPlaying
                        ? 'border-blue-400 bg-blue-400/20 text-blue-400'
                        : track.vocalVersion === "#"
                        ? 'border-gray-600 bg-gray-800/50 text-gray-500 cursor-not-allowed'
                        : audioLoadingStates[`${track.id}-vocal`] === 'ready'
                        ? 'border-green-400/50 bg-green-400/10 text-white hover:border-blue-400 hover:bg-blue-400/10 hover:text-blue-400'
                        : 'border-white/30 bg-transparent text-white hover:border-blue-400 hover:bg-blue-400/10 hover:text-blue-400'
                    }`}
                    title={
                      track.track_type === 'instrumental'
                        ? (audioLoadingStates[`${track.id}-vocal`] === 'ready' 
                            ? "Instrumental Version (Preloaded - Instant Play)" 
                            : audioLoadingStates[`${track.id}-vocal`] === 'loading'
                            ? "Instrumental Version (Loading...)"
                            : "Instrumental Version")
                        : (audioLoadingStates[`${track.id}-vocal`] === 'ready' 
                            ? "Vocal Version (Preloaded - Instant Play)" 
                            : audioLoadingStates[`${track.id}-vocal`] === 'loading'
                            ? "Vocal Version (Loading...)"
                            : "Vocal Version")
                    }
                  >
                    {currentTrack?.id === track.id && currentVersion === 'vocal' && isPlaying ? '⏸' : 
                     audioLoadingStates[`${track.id}-vocal`] === 'loading' ? '⏳' : 
                     track.track_type === 'instrumental' ? '🎹' : '🎤'}
                  </Button>

                  {/* Instrumental Version */}
                  <Button
                    onClick={() => handlePlayPause(track, 'instrumental')}
                    disabled={track.instrumentalVersion === "#"}
                    className={`w-10 h-10 rounded-full border transition-all duration-300 text-xs ${
                      currentTrack?.id === track.id && currentVersion === 'instrumental' && isPlaying
                        ? 'border-blue-400 bg-blue-400/20 text-blue-400'
                        : track.instrumentalVersion === "#"
                        ? 'border-gray-600 bg-gray-800/50 text-gray-500 cursor-not-allowed'
                        : 'border-white/30 bg-transparent text-white hover:border-blue-400 hover:bg-blue-400/10 hover:text-blue-400'
                    }`}
                    title="Instrumental Version"
                  >
                    {currentTrack?.id === track.id && currentVersion === 'instrumental' && isPlaying ? '⏸' : '🎼'}
                  </Button>
                </div>
              </div>
            </div>
          ))}
        </div>

        {/* Empty State */}
        {filteredTracks.length === 0 && (
          <div className="text-center py-16">
            <p className="text-gray-400 text-xl">No tracks found matching "{searchTerm}"</p>
          </div>
        )}

        {/* Track Count */}
        <div className="text-center mt-8 text-gray-400 text-sm">
          Showing {filteredTracks.length} of {tracks.length} tracks
        </div>
      </div>
    </section>
  );
};

export default Music;